/**
 * Author constants used throughout the application
 */

export const AUTHORS = {
  MINIFANTASYFICS: {
    id: 'MiniFantasyFics',
    slug: 'minifantasyfics',
    displayName: 'MiniFantasyFics',
    title: 'MiniFantasyFics',
    description: 'Explore enchanting fantasy tales and magical adventures. ft- Jimin',
    genre: 'fantasy',
  },
  MINITAEFF: {
    id: 'MiniTaeFF',
    slug: 'minitaeff',
    displayName: 'MiniTaeFF',
    title: 'MiniTaeFF',
    description: 'Immerse yourself in fan fiction stories and creative adaptations. ft- Taehyung',
    genre: 'fanfiction',
  },
  PURPLEKOOK: {
    id: 'PurpleKook',
    slug: 'purplekook',
    displayName: 'PurpleKook',
    title: 'PurpleKook',
    description: 'Discover captivating romance and emotional journeys. Ft- Jungkook',
    genre: 'romance',
  },
} as const;

/**
 * Array of all authors for navigation and iteration
 */
export const ALL_AUTHORS = [
  AUTHORS.MINIFANTASYFICS,
  AUTHORS.MINITAEFF,
  AUTHORS.PURPLEKOOK,
] as const;
